/* eslint-env browser */

import 'offcanvas';
import Domodule from 'domodule';
import { addClass, removeClass, on, find, closest } from 'domassist';
import isTouch from '../../_modules/feature-detect/touch';

if (isTouch()) {
  const dropdowns = find('.Header .dropdown');

  on(dropdowns, 'click', e => {
    const menu = closest(e.target, '.dropdown-menu');

    if (!menu) {
      e.preventDefault();
    }
  });
}

const CLASSES = {
  VISIBLE: 'search-visible'
};

class SearchUser extends Domodule {
  postInit() {
    this.searchVisible = false;
    this.els.header = document.getElementById('header');
    on(this.els.input, 'keydown', this.onKeydown.bind(this));
  }

  toggle() {
    if (this.searchVisible) {
      this.hide();
    } else {
      this.show();
    }
  }

  onKeydown(event) {
    if (event.keyCode === 27) {
      this.hide();
    }
  }

  hide() {
    removeClass(this.els.header, CLASSES.VISIBLE);
    this.els.showButton.focus();
    this.searchVisible = false;
  }

  show() {
    addClass(this.els.header, CLASSES.VISIBLE);
    setTimeout(() => { this.els.input.focus(); }, 500);
    this.searchVisible = true;
  }
}

Domodule.register('SearchUser', SearchUser);
